'use client'

import { useTranslation } from 'react-i18next'
import { GetPriceResponse } from '@leid/api-orders'

import { Pricing } from 'appTypes/items'

import SwitchBox from '../../../SwitchBox'

type Props = {
  value: boolean | undefined
  fieldName: string
  pricings: Pricing[]
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  productPrice: GetPriceResponse | null
  isProlonging: boolean
  amount: number
}

const IncludeInsuranceSwitch = (props: Props): JSX.Element => {
  const { pricings, setFieldValue, value, fieldName, productPrice, isProlonging, amount } = props

  const { t } = useTranslation(['common'])

  const activePricing = productPrice ? pricings.find((s) => s.id === productPrice.pricingId) : undefined

  const getPrice = () => {
    if (activePricing?.insurancePercentage && activePricing?.insurancePercentage !== 0) {
      const newPrice = productPrice?.insurancePrice ?? 0
      return newPrice
    }

    return (activePricing?.insurancePrice ?? 0) * amount
  }

  const isDisabled = () => {
    if (activePricing?.insurancePercentage && activePricing?.insurancePercentage !== 0) {
      return true
    }

    if (isProlonging || !activePricing?.insurancePrice || activePricing?.insurancePrice === 0) {
      return true
    }

    return false
  }

  const hide = false
  const price = getPrice()

  return (
    <>
      {!hide && (
        <SwitchBox
          title={t('insurance')}
          price={price}
          onChange={(value) => {
            setFieldValue(fieldName, value)
          }}
          defaultChecked={value}
          disabled={isDisabled()}
        />
      )}
    </>
  )
}

export default IncludeInsuranceSwitch
